import { SEARCH_TYPES } from './searchTypes';

export const OnSetSearchValue = (payload: string) => ({
  type: SEARCH_TYPES.ON_SET_SEARCH_VALUE,
  payload,
});
